// Live player-condition formatters (Stamina + Season fatigue). Shared by the
// lineup tables (Stam / SF columns) and the player card's condition line so the
// two surfaces render identical values from the same raw endurance ints.

// SF ("Season fatigue") column — legacy stats.ScoutInjury: '—' for 0/null,
// 'N%' otherwise (after rounding + clamping to 0-100). The integer cast handles
// the legacy Round() behavior; clamping keeps the display sane when raw data is
// dirty. Source column is players.injuryseverity (raw), exposed as
// PlayerEndurance.seasonFatigue on the player-view payload.
export function injuryDisplay(severity: number | null | undefined): string {
  if (severity == null) return '—'
  let v = Math.round(severity)
  if (v <= 0) return '—'
  if (v > 100) v = 100
  return `${v}%`
}

// Stam column — legacy formula Round(cratingen / ratingen * 100). Uses the raw
// endurance ints (RatingEnRaw / CRatingEn) since the strategy-projected
// PlayerRating "current" is a bucketed display string and can't divide.
export function stamDisplay(
  cRatingEn: number | null | undefined,
  ratingEnRaw: number | null | undefined,
): string {
  if (cRatingEn == null || ratingEnRaw == null || ratingEnRaw === 0) return '—'
  return `${Math.round((cRatingEn / ratingEnRaw) * 100)}%`
}
